import React from 'react';
import { Card, CardBody } from "@material-tailwind/react";

const TaskFilterBar = ({ children }) => {
    return (
        <Card className="shadow-sm border border-white/70">
            <CardBody className="space-y-4">
                {children}
            </CardBody>
        </Card>
    );
};

export default TaskFilterBar;
